import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isOpenSelector, setOpenAction, isNewChatSelector } from '@/domain/chat';
import { userIdSelector, chatTokenSelector, isDokkaSupportSelector } from '@/domain/env';

import ChatDrawer from '@/components/mui/Layouts/components/Chat/components/ChatDrawer';
import ChatButton from '@/components/mui/Layouts/components/Chat/components/ChatButton';
import ChatIconButton from '@/components/mui/Layouts/components/Chat/legacy/ChatIconButton';
import useChatChannelParam from '@/components/mui/Layouts/components/Chat/hooks/useChatChannelParam';
import Box from '@mui/material/Box';

import '@/components/mui/Layouts/components/Chat/styles.css';

const ChatLauncher: React.FC = () => {
  const dispatch = useDispatch();
  useChatChannelParam();

  const userID = useSelector(userIdSelector);
  const chatToken = useSelector(chatTokenSelector);
  const isChatOpen = useSelector(isOpenSelector);
  const isNewChat = useSelector(isNewChatSelector);
  const isGhost = useSelector(isDokkaSupportSelector);

  const isAvailable = chatToken && userID && !isGhost;

  const handleToggleChat = useCallback(() => {
    dispatch(setOpenAction(!isChatOpen));
  }, [dispatch, isChatOpen]);

  if (!isAvailable) return null;

  // New UIKit v4 chat
  if (isNewChat) {
    return (
      <Box>
        <ChatButton onOpen={handleToggleChat} />
        <ChatDrawer open={isChatOpen} onClose={handleToggleChat} />
      </Box>
    );
  }

  // Legacy v3 chat
  return <ChatIconButton />;
};

export default ChatLauncher;
